import { Maybe } from '@passionware/monads';
import { z } from 'zod';

export type StringFilterOperator = 'equals' | 'contains' | 'notContains';

export type StringFilter =
  | {
      operator: 'equals';
      value: string;
    }
  | {
      operator: 'contains';
      value: string;
    }
  | {
      operator: 'notContains';
      value: string;
    };

const stringValueSchema = z.string().trim();

export const stringFilterSchema = z.discriminatedUnion('operator', [
  z.object({
    operator: z.literal('equals'),
    value: stringValueSchema
  }),
  z.object({
    operator: z.literal('contains'),
    value: stringValueSchema
  }),
  z.object({
    operator: z.literal('notContains'),
    value: stringValueSchema
  })
]) as z.ZodType<StringFilter>;

export const stringFilter = {
  matches(
    filter: Maybe<StringFilter>,
    value: Maybe<string>,
    caseSensitive: boolean = false
  ): boolean {
    if (!filter) return true;
    const presentValue = value ?? '';
    const valueToCompare = caseSensitive
      ? presentValue
      : presentValue.toLowerCase();
    const filterValueToCompare = caseSensitive
      ? filter.value
      : filter.value.toLowerCase();

    switch (filter.operator) {
      case 'equals':
        return valueToCompare === filterValueToCompare;
      case 'contains':
        return valueToCompare.includes(filterValueToCompare);
      case 'notContains':
        return !valueToCompare.includes(filterValueToCompare);
    }
  }
};
